import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    const fullUrl = `${window.location.origin}${path}`;
    const cfg = window.__FORMATS_ANALYTICS_CONFIG__ || {};

    if (cfg.gaId && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_title: document.title,
        page_path: path,
        page_location: fullUrl
      });
    }

    if (cfg.yandexId && typeof window.ym === "function") {
      window.ym(Number(cfg.yandexId), "hit", path, {
        title: document.title,
        referer: document.referrer
      });
    }

    if (cfg.mailruId && Array.isArray(window._tmr)) {
      window._tmr.push({
        id: cfg.mailruId,
        type: "pageView",
        pageUrl: fullUrl
      });
    }
  }, [location]);

  return null;
}
